import { combineReducers } from 'redux'
import userReducer from './userReducer'
import profileReducer from './profileReducer'
import callReportReducer from './callReportReducer'
import teamMemberReducer from './teamMemberReducer'
import domainReducer from './domainReducer'
import accessibilityReducer from './accessibilityReducer'
import accessReducer from './accessReducer'
import getAllUsersReducer from './getAllUsersReducer'
import packageReducer from './packageReducer'
import transactionReducer from './transactionReducer'
import settingReducer from './settingReducer'
import commonReducer from './commonReducer'
import notificationReducer from './notificationReducer'
import supportReducer from './supportReducer'
import tenantMemberReducer from './tenantMemberReducer'


const initialState = {
  sidebarShow: true,
  userEmail: '',
  webAddressWizard: '',
  userPackageId: ''
}

const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case 'set':
      return { ...state, ...rest }
    case 'userEmail':
      return {
        ...state,
        userEmail: rest.payload
      }
    case 'webAddressWizard':
      return {
        ...state,
        webAddressWizard: rest.payload
      }
    case 'userPackageId':
      return {
        ...state,
        userPackageId: rest.payload
      }
    default:
      return state
  }
}
const rootReducer = combineReducers({
  userReducer,
  profileReducer,
  callReportReducer,
  teamMemberReducer,
  domainReducer,
  changeState,
  accessibilityReducer,
  accessReducer,
  getAllUsersReducer,
  packageReducer,
  transactionReducer,
  settingReducer,
  commonReducer,
  notificationReducer,
  supportReducer,
  tenantMemberReducer
})

export default rootReducer
